module.exports = __webpack_public_path__ + "static/media/bidspotter-com_logo.e9b11323.png";